// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608200930/js/" + chunkId + "." + {"44":"95f7d73f","225":"fa48dc27","481":"b9fcc31f","486":"7ad0447d","770":"c8c570c9"}[chunkId] + ".0.6645096798950569.chunk.js";
};